// PRJ1417943 - Integration Accelerator - Centralized UI config for LinkServiceLookup - replaces hardcoded app.appSlug conditionals (dmvrr, tpwdas)
export const linkServiceUiConfig = {
  dmvrr: {
    subtitle: true,
    guidanceModal: 'LinkingGuidanceModal',
    guidanceTextKey: 'dmvrr_LinkService_LookupVehicleLinkReq',
  },
  tpwdas: {
    subtitle: true,
    subtitleModal: 'TPWDSubtitleModal',
  },
  txhhschip: {
    subtitle: true
  },
};
